import CardBuilder from '@legacy-vfuk/core-card-builder';
import CardHeadingAndIconSlot from '@legacy-vfuk/core-card-heading-and-icon-slot';
import CardIconSnippetSlot from '@legacy-vfuk/core-card-icon-snippet-slot';
import CardImageSlot from '@legacy-vfuk/core-card-image-slot';
import Icon from '@legacy-vfuk/core-icon';
import { getImage, getSrc } from 'gatsby-plugin-image';
import React, { FC } from 'react';

import { Article } from '../../../../types/Article.types';
import { Wrapper } from './SWArticleCard.styles';
import usingOpcoUrl from '@/helpers/prefixHelper';

const SWArticleCard: FC<Article> = ({ id, categories, name, thumbnail, summary, slug }: Article) => {
  const imageSlotSrc = getSrc(thumbnail) || getImage(thumbnail)?.placeholder?.fallback || '';

  const imageSlot = {
    alt: thumbnail?.title,
    backgroundImage: {
      sm: {
        src: imageSlotSrc,
      },
    },
  };

  return (
    <Wrapper>
      <CardBuilder key={id}>
        <CardHeadingAndIconSlot
          icon={{
            name: '',
            component: <CardImageSlot {...imageSlot} />,
          }}
          heading={{ name: categories ? categories[0].name : '' }}
          link={{
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore: Component CardHeadingAndIconSlot don't accept receiving a ReactNode at the text prop
            text: (
              <>
                {name}
                <Icon name="chevron-right" group="system" size={2} appearance="secondary" />
              </>
            ),
            href: usingOpcoUrl(`${slug}`) || '#',
          }}
        />
        <CardIconSnippetSlot headingText="" icon={{ name: '' }} text={summary} />
      </CardBuilder>
    </Wrapper>
  );
};

export default SWArticleCard;
